<template>
  <modal-card title="Send Email Preview" fixed padding @close="$emit('close')">
    <v-form ref="form" class="mt-6">
      <field-block title="Email Addresses">
        <p>
          Enter email addresses you want to send a preview to (max 3, separated
          by commas)
        </p>
        <v-textarea
          label="Email"
          v-model="previewEmails"
          :rules="[rules.required]"
          auto-grow
          rows="2"
        />
      </field-block>

      <field-block title="Contact">
        <p>
          Select a contact for testing data placeholders. The contact WILL NOT
          receive this message. It's just for testing formatting.
        </p>
        <v-select label="Contact" v-model="selectedContact" :items="contacts" />
      </field-block>
    </v-form>

    <template v-slot:actions>
      <v-btn color="appMain" class="ml-4" @click="sendPreview"
        >Send Test Email</v-btn
      >
    </template>
  </modal-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getContactName } from '@/filters/helpers';
import validationRules from '@/lib/validationRules';
import clone from 'lodash/clone';

export default {
  name: 'EmailSendTestModal',
  props: {
    email: {},
  },
  data() {
    return {
      previewEmails: '',
      contacts: [],
      selectedContact: null,
      rules: {
        required: (v) => validationRules.checkRequired(v) || '',
      },
    };
  },
  computed: {
    ...mapGetters('users', ['currentUser']),
    ...mapGetters('fields', ['getSingleField']),
  },
  methods: {
    ...mapActions(['createMessage', 'loadFilteredContacts']),
    isValid() {
      return this.$refs.form.validate();
    },
    sendPreview() {
      if (!this.isValid()) return;

      let message = {
        ...clone(this.email),
        preview: this.previewEmails,
        type_id: this.selectedContact,
        type: '',
      };

      this.createMessage(message).then(() => {
        this.$emit('close');
      });
    },
    loadContacts() {
      this.loadFilteredContacts({
        filters: {},
      }).then(({ results }) => {
        if (!Array.isArray(results) || !results.length) return;

        this.contacts = results.map((i) => {
          return { text: getContactName(i), value: i.con_id };
        });

        this.selectedContact = this.contacts[0].value;
      });
    },
  },
  mounted() {
    this.previewEmails = this.currentUser?.email;
    this.loadContacts();
  },
};
</script>
